import {
  InvoiceID,
  InvoiceNanoID,
  InvoiceChargebackCacheKeys,
  InvoiceChargebackGqlQuery,
  InvoiceUUID
} from '../../invoicesTypes';

import { CACHE_INVOICE_CHARGEBACK_QUERY } from '../../queries/cacheInvoiceChargeback.query';

import { useCacheUpdateQuery } from '../../../common/reactQuery/hooks/useCacheUpdateQuery';

interface CacheInvoiceChargebackOptions {
  query?: InvoiceChargebackGqlQuery;
  cacheKeys?: InvoiceChargebackCacheKeys;
}

export interface CacheInvoiceChargebackResponse {
  invoiceChargeback: {
    statusCode: number;
    message: string;
  };
}

export interface CacheInvoiceChargebackInput {
  uuid: InvoiceID | InvoiceNanoID | InvoiceUUID;
}

// TODO:
// Add error type for nest gql mutation response
export type CacheInvoiceChargebackError = null;

const action = 'invoiceChargeback';

function useCacheInvoiceChargeback<CacheInvoiceChargebackRecordType = unknown>({
  query = CACHE_INVOICE_CHARGEBACK_QUERY,
  cacheKeys
}: CacheInvoiceChargebackOptions = {}) {
  const {
    updateCacheQuery,
    updateCacheQueryData,
    updateCacheQueryError,
    updateCacheQueryErrorMessage,
    updateCacheQueryLoading,
    updateCacheQueryReset
  } = useCacheUpdateQuery<
    CacheInvoiceChargebackInput,
    CacheInvoiceChargebackResponse,
    CacheInvoiceChargebackError,
    CacheInvoiceChargebackRecordType
  >({ action, query, cacheKeys });

  return {
    invoiceChargeback: updateCacheQuery,
    invoiceChargebackData: updateCacheQueryData,
    invoiceChargebackError: updateCacheQueryError,
    invoiceChargebackErrorMessage: updateCacheQueryErrorMessage,
    invoiceChargebackLoading: updateCacheQueryLoading,
    invoiceChargebackReset: updateCacheQueryReset
  };
}

export default useCacheInvoiceChargeback;
